import useTranslation from 'next-translate/useTranslation';

// Components
import { PermanentEmptyState } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/PermanentEmptyState';

// Types
import type { PermanentEmptyStateProps } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/PermanentEmptyState';
import type { SocialProfileType } from '@/types/socialProfileType';

type SocialProfileEmptyStateProps = Pick<
    PermanentEmptyStateProps,
    'supportedNetworkTypes' | 'emptyStateName'
> & {
    socialProfileNetworkType: SocialProfileType['social_network_type'];
};

export function SocialProfileEmptyState({
    emptyStateName,
    supportedNetworkTypes,
    socialProfileNetworkType
}: SocialProfileEmptyStateProps) {
    const { t } = useTranslation('layout_platform');

    const title =
        emptyStateName && socialProfileNetworkType
            ? t(`empty_states.social_profile.${emptyStateName}.${socialProfileNetworkType}.title`)
            : t(`empty_states.social_profile.title`);

    const description =
        emptyStateName && socialProfileNetworkType
            ? t(
                  `empty_states.social_profile.${emptyStateName}.${socialProfileNetworkType}.description`
              )
            : t(`empty_states.social_profile.description`);

    const displayEmptyStateUpVote = shouldDisplayEmptyStateUpVote(
        emptyStateName,
        socialProfileNetworkType
    );

    return (
        <div data-testid="social-profile-empty-state" className="flex-1">
            <PermanentEmptyState
                title={title}
                description={description}
                supportedNetworkTypes={supportedNetworkTypes}
                emptyStateName={`${emptyStateName}.${socialProfileNetworkType}`}
                displayEmptyStateUpVote={displayEmptyStateUpVote}
            />
        </div>
    );
}

const shouldDisplayEmptyStateUpVote = (
    emptyStateName: string,
    socialProfileNetworkType: SocialProfileType['social_network_type']
) => {
    const emptyStatesWithoutUpVote = [
        'publishing.media-library.pinterest',
        'publishing.media-library.youtube',
        'publishing.saved-captions-hashtags.pinterest',
        'publishing.saved-captions-hashtags.youtube',
        'publishing.scheduler.feed-preview.facebook',
        'publishing.scheduler.feed-preview.linkedin',
        'publishing.scheduler.feed-preview.tiktok_business',
        'conversations.mentions.linkedin',
        'conversations.mentions.pinterest',
        'conversations.mentions.youtube',
        'listening.youtube',
        'listening.pinterest',
        'listening.linkedin',
        'listening.facebook'
    ];
    return !emptyStatesWithoutUpVote.includes(`${emptyStateName}.${socialProfileNetworkType}`);
};
